import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('ButtonSelect', null, { withChildren: true });
